module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Frank's Blog","short_name":"Frank's Blog","description":"Hier schrijf ik over legal en tech.","start_url":"/","lang":"nl","background_color":"#FEFBF4","theme_color":"#09192B","display":"standalone","icon":"src/assets/img/512-512-favicon.svg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"bcaee71808622117bf3010becaa6d405"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
